
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.21 11H11v9a1 1 0 002 0v-9h1.79a.5.5 0 00.35-.85l-2.79-2.79a.5.5 0 00-.71 0l-2.79 2.79a.5.5 0 00.36.85zM4 4a1 1 0 001 1h14a1 1 0 000-2H5a1 1 0 00-1 1z"}})])
          )
        }
      }
    